import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const LS_KEY = "iq_cart_v1";

function loadInitial() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(loadInitial);

  useEffect(() => {
    localStorage.setItem(LS_KEY, JSON.stringify(items));
  }, [items]);

  /**
   * item: { id, kind: 'tour'|'accommodation'|'leg', name, sub, price_eur, qty, image?, meta? }
   */
  const addItem = (item) => {
    setItems((prev) => {
      const existing = prev.find((p) => p.id === item.id && p.kind === item.kind);
      if (existing) {
        return prev.map((p) => (p === existing ? { ...p, qty: p.qty + (item.qty || 1) } : p));
      }
      return [...prev, { qty: 1, ...item }];
    });
  };

  const removeItem = (id, kind) => {
    setItems((prev) => prev.filter((p) => !(p.id === id && p.kind === kind)));
  };

  const updateQty = (id, kind, qty) => {
    setItems((prev) => prev.map((p) => (p.id === id && p.kind === kind ? { ...p, qty: Math.max(1, qty) } : p)));
  };

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, x) => s + x.price_eur * x.qty, 0);
  const count = items.reduce((s, x) => s + x.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
